"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOCK_CART_ITEM_MODEM = void 0;
const index_1 = require("../../generated-source/api/index");
exports.MOCK_CART_ITEM_MODEM = {
    sku: '14x14613031',
    cartItemId: '22555',
    additionalData: {
        parentSku: '14x13858883',
        productCategory: index_1.ProductCategory.Modem,
        productQualification: null,
        productDisplayAttributes: {
            productName: 'Comnect Modem',
            price: '0',
        },
        parentCartItemId: '22554',
    },
};
//# sourceMappingURL=cart-item-modem.mock.js.map